var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { v4 } from 'uuid';
// import { Storage } from 'aws-amplify';
import { getUrl, uploadData } from 'aws-amplify/storage';
import { Amplify } from 'aws-amplify';
import { removeSpecialCharacters } from './regex';
import { getMediaType, supportedMimeTypes } from '../constants/enums';
import { IMAGE_PLACEHOLDER } from '../constants/standard';
export function splitFileNameAndExtension(fileName) {
    return {
        name: fileName.substring(0, fileName.lastIndexOf('.')),
        ext: fileName.substring(fileName.lastIndexOf('.')),
    };
}
export function normalizeFileName(fileName) {
    const { name, ext } = splitFileNameAndExtension(fileName);
    return removeSpecialCharacters(name, '_-') + ext;
}
export function getFileNameFromPath(path) {
    return path.lastIndexOf('/') > -1 ? path.substring(path.lastIndexOf('/') + 1) : path;
}
export function uploadFile(file, additionalMetadata, identity, bucket) {
    return __awaiter(this, void 0, void 0, function* () {
        if (file) {
            const { type: mimeType, name } = file;
            const uuid = v4();
            const key = `${uuid}-${normalizeFileName(name)}`;
            const mediaType = getMediaType(mimeType);
            const metadata = Object.assign({ id: uuid, account: identity.account_id, created_by: identity.id, media_type: mediaType }, additionalMetadata);
            Object.keys(metadata).forEach((key) => {
                metadata[key] = metadata[key] != null ? metadata[key].toString() : '';
            });
            // console.log('BEGIN uploadFile')
            // console.log(mimeType)
            // console.log(mediaType)
            // console.log(key)
            // console.log(file)
            // console.log({
            //   bucket,
            //   region: REGION,
            //   customPrefix: {
            //     public: ''
            //   },
            //   metadata,
            //   contentType: mimeType
            // })
            // console.log('END uploadFile')
            try {
                // await Storage.put(`${bucket.includes('userimages') ? 'public/' : ''}${key}`, file, {
                //   bucket,
                //   region: REGION,
                //   customPrefix: {
                //     public: '',
                //   },
                //   metadata,
                //   contentType: mimeType,
                // });
                Amplify.configure(Object.assign(Object.assign({}, Amplify.getConfig()), { Storage: {
                        S3: {
                            bucket,
                            region: 'eu-west-1',
                        },
                    } }));
                yield uploadData({
                    key: `${bucket.includes('userimages') ? 'public/' : ''}${key}`,
                    data: file,
                    options: {
                        metadata,
                        contentType: mimeType,
                        // onProgress, // Optional progress callback.
                    },
                });
                return Object.assign(Object.assign({ uuid }, splitFileNameAndExtension(name)), { key, mimeType, mediaType });
            }
            catch (err) {
                console.log('upload', err);
                return {};
            }
        }
    });
}
export function getImageInfo(image) {
    if (!image)
        return '';
    const { pathname } = new URL(image.src);
    const fileName = getFileNameFromPath(pathname);
    const { name, ext } = splitFileNameAndExtension(fileName);
    const mimeType = supportedMimeTypes.image.find((mime) => mime.indexOf(ext) > -1) || supportedMimeTypes.image[0];
    return { pathname, fileName, name, ext, mimeType };
}
export function getFileFromImg(img) {
    return __awaiter(this, void 0, void 0, function* () {
        const { mimeType } = getImageInfo(img);
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!window.fetch) {
            return fetch(img.src)
                .then((res) => res.blob())
                .then((blob) => {
                let fileName = (img === null || img === void 0 ? void 0 : img.alt) || 'alt.jpg';
                if (!fileName) {
                    const { pathname } = new URL(img.src);
                    fileName = getFileNameFromPath(pathname);
                }
                const file = new File([blob], normalizeFileName(fileName), { type: mimeType });
                return file;
            });
        }
        return new Promise((resolve, reject) => {
            try {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', img.src);
                xhr.responseType = 'blob';
                // eslint-disable-next-line func-names
                xhr.onload = function () {
                    const blob = xhr.response;
                    let fileName = (img === null || img === void 0 ? void 0 : img.alt) || 'alt.jpg';
                    if (!fileName) {
                        const { pathname } = new URL(img.src);
                        fileName = getFileNameFromPath(pathname);
                    }
                    const file = new File([blob], normalizeFileName(fileName), { type: mimeType });
                    resolve(file);
                };
                xhr.send();
            }
            catch (error) {
                console.log('getFileFromUrl', img, mimeType, error);
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({});
            }
        });
    });
}
export function loadImageFromS3(name_1, bucket_1) {
    return __awaiter(this, arguments, void 0, function* (name, bucket, placeholder = IMAGE_PLACEHOLDER) {
        if (name && name.length > 10) {
            Amplify.configure(Object.assign(Object.assign({}, Amplify.getConfig()), { Storage: {
                    S3: {
                        bucket,
                        region: 'eu-west-1',
                    },
                } }));
            return getUrl({
                key: name,
                // options: {
                //   // bucket,
                //   // region: REGION,
                //   // customPrefix: {
                //   //   public: '',
                //   // },
                // },
            }).then((data) => data.url.href.replace('/public', ''), (error) => {
                console.log('loadImageFromS3', error);
                return placeholder;
            });
        }
        // console.log('loadImageFromS3 no [name && name.length > 10]')
        return placeholder;
    });
}
export function loadReportsFromS3(name, bucket) {
    return __awaiter(this, void 0, void 0, function* () {
        Amplify.configure(Object.assign(Object.assign({}, Amplify.getConfig()), { Storage: {
                S3: {
                    bucket,
                    region: 'eu-west-1',
                },
            } }));
        return getUrl({
            key: name,
            // options: {
            //   // bucket,
            //   // region: REGION,
            //   // customPrefix: {
            //   //   public: '',
            //   // },
            // },
        }).then((data) => data.url.href, (error) => {
            console.log('loadExportedDocFromS3', error);
            return null;
        });
    });
}
export function getFileFromInput(event) {
    let file = !!event.target && ((!!event.target.files && event.target.files[0]) || event.target.value);
    if (!file) {
        file = !!event.dataTransfer && !!event.dataTransfer.files && event.dataTransfer.files[0];
    }
    return file;
}
